import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { getAttributionParams, trackEvent, trackPageView } from "../lib/analytics";

const PageShell = ({ children, className = "" }) => {
  const location = useLocation();

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (location.hash) {
        const target = document.querySelector(location.hash);
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
      }

      window.scrollTo({ top: 0, behavior: "auto" });
    }, 0);

    return () => window.clearTimeout(timer);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const attribution = getAttributionParams();
    trackPageView(attribution);

    const pageEventMap = {
      "/": "homepage_view",
      "/home": "homepage_view",
      "/product": "product_page_view",
      "/usecases": "use_cases_page_view",
      "/services": "services_page_view",
      "/terms": "terms_page_view",
      "/privacy": "privacy_page_view",
      "/thank-you": "thank_you_view",
    };

    const pageEvent = pageEventMap[location.pathname];
    if (pageEvent) {
      trackEvent(pageEvent, attribution);
    }

    if (location.pathname === "/thank-you") {
      trackEvent("demo_request_conversion", attribution);
    }
  }, [location.pathname, location.hash, location.search]);

  return (
    <div className={`marketing-page ${className}`}>
      <Navbar />
      <main className="marketing-main">{children}</main>
      <Footer />
    </div>
  );
};

export default PageShell;
